var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useCallback, useEffect, useRef, } from 'react';
import EditorJS from '@editorjs/editorjs';
import Paragraph from '@editorjs/paragraph';
import Header from '@editorjs/header';
var DEFAULT_ID = 'editorjs';
var EditorJs = function (props) {
    var deprecatedId = props.holderId, customHolderId = props.holder, editorInstance = props.editorInstance, reinitializeOnPropsChange = props.reinitializeOnPropsChange, children = props.children, tools = props.tools, otherProps = __rest(props, ["holderId", "holder", "editorInstance", "reinitializeOnPropsChange", "children", "tools"]);
    var instance = useRef(null);
    var holderId = deprecatedId || customHolderId || DEFAULT_ID;
    var initEditor = useCallback(function () {
        if (instance && !instance.current) {
            instance.current = new EditorJS(__assign({ tools: __assign({ paragraph: {
                        class: Paragraph,
                        inlineToolbar: true,
                    }, header: Header }, tools), holder: holderId }, otherProps));
        }
        if (editorInstance) {
            editorInstance(instance.current);
        }
    }, [editorInstance, holderId, otherProps, tools]);
    useEffect(function () {
        initEditor();
        return function () {
            if (instance.current && reinitializeOnPropsChange) {
                instance.current.isReady.then(function () {
                    instance.current.destroy();
                    instance.current = undefined;
                    initEditor();
                });
            }
        };
    }, [initEditor, reinitializeOnPropsChange]);
    return children || React.createElement("div", { id: holderId });
};
export default memo(EditorJs);
//# sourceMappingURL=editor.js.map